import React, { Component } from 'react';
import { setCookie, getCookie, delCookie, getCookieAmend } from '../../util/cookie';
import NewPictureBox from '../../components/allTypePictureBox/posterForHistory/posterForHistory';
import Marquee from '../../components/marquee/marquee';
import { Link } from 'react-router-dom';
import '../../apis/base';
import './mine.scss';
import { $tv } from 'react-tv-focusable';
import $api from '../../apis/index';
import { report } from '../../util/dataReporting';
import { generatePaySessionId, getAccountPicture, getLocalRecords, paySessionIdKey } from '../../util/util';
import { withCustomTranslation } from '@/hooks/useCustomTranslation';
import Event, { EVENTS } from '../../util/event';
export default withCustomTranslation(class NewMine extends Component {
  constructor(props) {
    super(props);
    this.allHistoryMark = React.createRef();
    this.setUpMark = React.createRef();
    this.helpMark = React.createRef();
    this.aboutUsMark = React.createRef();
    this.loginMark = React.createRef();
    this.logoutMark = React.createRef();
    this.renewMark = React.createRef();
    this.openMark = React.createRef();
    this.state = {
      allImg: require('../../assets/img/allHistory_s.png'),
      setUpImg: require('../../assets/img/setUp_s.png'),
      helpImg: require('../../assets/img/help_s.png'),
      aboutUsImg: require('../../assets/img/aboutUs_s.png'),
      accountImg: '', // 账号类型图片
      vipImg: require('../../assets/img/accoun/vip.png'), // vip图片
      avatar: '', // 用户图片
      headerflag: '',
      posterAtion: '',
      allHistoryAtion: '',
      historyAnimation: '',
      logoutFlag: false,
      renewFlag: false,
      loginFlag: false,
      loginAtion: '',
      aboutUsAtion: '',
      history: [],
      user_nick: '', // 用户呢称
      end: '', // 会员结束时间戳
      status: '', // 会员状态 1: 游客 2: 登陆状态非会员 3: 会员
      user_type: '', // 账号类型 1：facebook  2：line  3：手机号  4：邮箱  6：苹果 7:微信  9:google
      isLogin: false, // 是否登录
      mineEntryTime: '', // 我的页停留时间
      historyIdx: 0, // 历史记录聚焦索引
      paySessionId: generatePaySessionId(),
    };
  }
  // 去除所有的mouseenter事件
  componentWillMount() {
    if (getCookieAmend('isLogin')) {
      const userNick = getCookieAmend('user_nick');
      const avatar = getCookieAmend('avatar');
      const isLogin = getCookieAmend('isLogin');
      this.setState({
        user_nick: userNick ? userNick : 'WeTV',
        avatar,
        isLogin,
      });
      this.GetRPCQueryHistory();
      if (getCookieAmend('status')) {
        const status = getCookieAmend('status');
        const end = getCookieAmend('end');
        this.setState({
          status,
          end,
        });
      } else {
        this.setState({
          status: '',
          end: '',
        });
      }
      this.setState({
        accountImg: getAccountPicture(),
      });
    } else {
      if (localStorage.getItem('localHistory')) {
        const records = getLocalRecords();
        this.GetRPCQueryHistoryUiData(records);
      } else {
        this.GetRPCQueryHistoryUiData();
      }
      this.setState({
        avatar: '',
        isLogin: false,
      });
    }
  }
  componentDidMount() {
    // 我的页面进入上报
    report({
      attaId: '0cb00063509',
    });
    this.setState({
      mineEntryTime: new Date().getTime(),
    });
    $tv.distanceToCenter = true;
    delCookie('historyMark');
    delCookie('allHistoryMark');
    if (this.state.isLogin) {
      // 退出登录
      this.logoutMark.current.addEventListener('onFocus', this.logoutFocus.bind(this));
      this.logoutMark.current.addEventListener('onBlur', this.logoutBlur.bind(this));
      this.logoutMark.current.addEventListener('up', this.logoutUp.bind(this));
      this.logoutMark.current.addEventListener('down', this.logoutDown.bind(this));
      this.logoutMark.current.addEventListener('left', this.logoutLeft.bind(this));
      this.logoutMark.current.addEventListener('click', this.logoutClick.bind(this));
      this.logoutMark.current.addEventListener('mouseenter', this.logoutMouseenter.bind(this));

      // 续费和开通
      this.renewMark.current.addEventListener('onFocus', this.renewFocus.bind(this));
      this.renewMark.current.addEventListener('onBlur', this.renewBlur.bind(this));
      this.renewMark.current.addEventListener('up', this.renewUp.bind(this));
      this.renewMark.current.addEventListener('down', this.renewDown.bind(this));
      this.renewMark.current.addEventListener('click', this.renewClick.bind(this));
      this.renewMark.current.addEventListener('mouseenter', this.renewMouseenter.bind(this));
    } else {
      // 登录
      this.loginMark.current.addEventListener('onFocus', this.loginFocus.bind(this));
      this.loginMark.current.addEventListener('onBlur', this.loginBlur.bind(this));
      this.loginMark.current.addEventListener('up', this.loginUp.bind(this));
      this.loginMark.current.addEventListener('down', this.loginDown.bind(this));
      this.loginMark.current.addEventListener('left', this.loginLeft.bind(this));
      this.loginMark.current.addEventListener('click', this.loginClick.bind(this));
      this.loginMark.current.addEventListener('mouseenter', this.loginMouseenter.bind(this));
    }
    // 查看更多历史
    this.allHistoryMark.current.addEventListener('onFocus', this.allImgFocus.bind(this));
    this.allHistoryMark.current.addEventListener('onBlur', this.allImgBlur.bind(this));
    this.allHistoryMark.current.addEventListener('right', this.allImgRight.bind(this));
    this.allHistoryMark.current.addEventListener('left', this.allImgLeft.bind(this));
    this.allHistoryMark.current.addEventListener('up', this.allImgUp.bind(this));
    this.allHistoryMark.current.addEventListener('click', this.allImgClick.bind(this));
    this.allHistoryMark.current.addEventListener('mouseenter', this.allImgMouseenter.bind(this));
    // 设置
    this.setUpMark.current.addEventListener('onFocus', this.setUpFocus.bind(this));
    this.setUpMark.current.addEventListener('onBlur', this.setUpBlur.bind(this));
    this.setUpMark.current.addEventListener('left', this.setUpLeft.bind(this));
    this.setUpMark.current.addEventListener('right', this.setUpRight.bind(this));
    this.setUpMark.current.addEventListener('up', this.setUpUp.bind(this));
    this.setUpMark.current.addEventListener('down', this.setUpDown.bind(this));
    this.setUpMark.current.addEventListener('click', this.setUpClick.bind(this));
    this.setUpMark.current.addEventListener('mouseenter', this.setUpMouseenter.bind(this));
    // 帮助
    this.helpMark.current.addEventListener('onFocus', this.helpFocus.bind(this));
    this.helpMark.current.addEventListener('onBlur', this.helpBlur.bind(this));
    this.helpMark.current.addEventListener('left', this.helpLeft.bind(this));
    this.helpMark.current.addEventListener('right', this.helpRight.bind(this));
    this.helpMark.current.addEventListener('up', this.helpUp.bind(this));
    this.helpMark.current.addEventListener('down', this.helpDown.bind(this));
    this.helpMark.current.addEventListener('click', this.helpClick.bind(this));
    this.helpMark.current.addEventListener('mouseenter', this.helpMouseenter.bind(this));
    // 关于
    this.aboutUsMark.current.addEventListener('onFocus', this.aboutUsFocus.bind(this));
    this.aboutUsMark.current.addEventListener('onBlur', this.aboutUsBlur.bind(this));
    this.aboutUsMark.current.addEventListener('right', this.aboutUsRight.bind(this));
    this.aboutUsMark.current.addEventListener('left', this.aboutUsLeft.bind(this));
    this.aboutUsMark.current.addEventListener('up', this.aboutUsUp.bind(this));
    this.aboutUsMark.current.addEventListener('down', this.aboutUsDown.bind(this));
    this.aboutUsMark.current.addEventListener('click', this.aboutUsClick.bind(this));
    this.aboutUsMark.current.addEventListener('mouseenter', this.aboutUsMouseenter.bind(this));
    // const vChannelId = localStorage.getItem('v_channel_id');
    // const isUseNewHome = vChannelId === '16614' || vChannelId === '16562' || vChannelId === '16563';
    // if (localStorage.getItem('v_channel_id') === '16614') {
    // if (isUseNewHome) {
    if (this.props.headerflag === 2) {
      $tv.distanceToCenter = true;
      this.setState({
        headerflag: this.props.headerflag,
      });
      if (getCookie('focalMemory')) {
        const focalMemory = getCookie('focalMemory');
        if (focalMemory === 4) {
          $tv.requestFocus(this.allHistoryMark.current);
        } else if (focalMemory === 5) {
          $tv.requestFocus(this.aboutUsMark.current);
        } else if (focalMemory === 6) {
          $tv.requestFocus(this.helpMark.current);
        } else if (focalMemory === 7) {
          $tv.requestFocus(this.setUpMark.current);
        } else if (focalMemory === 8) {
          if (this.loginMark.current) {
            $tv.requestFocus(this.loginMark.current);
          } else {
            $tv.requestFocus(this.logoutMark.current);
          }
        } else if (focalMemory === 9) {
          if (this.logoutMark.current) {
            $tv.requestFocus(this.logoutMark.current);
          } else {
            $tv.requestFocus(this.loginMark.current);
          }
        } else if (focalMemory === 10) {
          if (this.renewMark.current) {
            $tv.requestFocus(this.renewMark.current);
          } else {
            $tv.requestFocus(this.loginMark.current);
          }
        } else {
          const historyMark = getCookie('historyMark');
          if (this.refs[`historyMark${historyMark}`] !== undefined) {
            $tv.requestFocus(this.refs[`historyMark${historyMark}`]);
          } else {
            $tv.requestFocus(this.allHistoryMark.current);
          }
        }
      }
    }
    // }
  }
  // 监听传值
  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentHeaderflag = nextProps.headerflag;
    if (nextProps.status) {
      this.setState({
        status: nextProps.status,
      });
    }
    if (nextProps.end) {
      this.setState({
        end: nextProps.end,
      });
    }
    if (currentHeaderflag === 2) {
      $tv.distanceToCenter = false;
      this.setState({
        headerflag: currentHeaderflag,
      });
      if (getCookie('focalMemory')) {
        const focalMemory = getCookie('focalMemory');
        if (focalMemory === 4) {
          $tv.requestFocus(this.allHistoryMark.current);
        } else if (focalMemory === 5) {
          $tv.requestFocus(this.aboutUsMark.current);
        } else if (focalMemory === 6) {
          $tv.requestFocus(this.helpMark.current);
        } else if (focalMemory === 7) {
          $tv.requestFocus(this.setUpMark.current);
        } else if (focalMemory === 8) {
          if (this.loginMark.current) {
            $tv.requestFocus(this.loginMark.current);
          } else {
            $tv.requestFocus(this.logoutMark.current);
          }
        } else if (focalMemory === 9) {
          if (this.logoutMark.current) {
            $tv.requestFocus(this.logoutMark.current);
          } else {
            $tv.requestFocus(this.loginMark.current);
          }
        } else if (focalMemory === 10) {
          if (this.renewMark.current) {
            $tv.requestFocus(this.renewMark.current);
          } else {
            $tv.requestFocus(this.loginMark.current);
          }
        }
      } else {
        if (this.state.isLogin) {
          $tv.requestFocus(this.logoutMark.current);
        } else {
          $tv.requestFocus(this.loginMark.current);
        }
      }
    }
  }
  componentWillUnmount() {
    // 这个上报切换到新主页了
    // const staytime = new Date().getTime() - this.state.mineEntryTime;
    // // 我的页面分tab曝光离开
    // report({
    //   attaId: '0cb00063509',
    //   staytime,
    // });
    // setCookie('ref_page', 'linuxtv_account'); // 我的页面的上个页面id
    $tv.distanceToCenter = false;
    this.setState = () => false;
  }
  // 获取历史观看数据
  GetRPCQueryHistory() {
    const body = {
      data_version: 0,
      page_context: '',
    };
    $api
      .GetRPCQueryHistory(body, {})
      .then((res) => {
        if (res && !res.code && !res.errCode && !res.err_code) {
          const currentUpdated = res.updated;
          const records = [];
          if (currentUpdated.length) {
            for (let i = 0; i < currentUpdated.length; i++) {
              if (currentUpdated[i].operation_type !== 3) {
                records.push({
                  vid: currentUpdated[i].record.vid,
                  cid: currentUpdated[i].record.cid,
                  modifyTime: currentUpdated[i].record.modify_time,
                  videoPlayTime: currentUpdated[i].record.video_play_time,
                  videoTotalTime: currentUpdated[i].record.video_total_time,
                });
              }
            }
            this.GetRPCQueryHistoryUiData(records);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // 获取历史数据的ui数据
  GetRPCQueryHistoryUiData(records) {
    const body = {
      records,
    };
    $api
      .GetRPCQueryHistoryUiData(body, {})
      .then((res) => {
        if (res && !res.code && !res.errCode && !res.err_code) {
          let uiData = [];
          if (this.state.isLogin) {
            uiData = res.ui_data;
          } else {
            uiData = res.ui_data.reverse();
          }
          // const uiData = res.data.ui_data.reverse();
          const history = [];
          for (let i = 0; i < uiData.length; i++) {
            let id = '';
            const labels = {};
            let watchProgress = '';
            if (uiData[i].record !== null && uiData[i].poster !== null) {
              if (uiData[i].record.type === 3) {
                watchProgress = '';
                id = uiData[i].record.pid;
              } else {
                watchProgress = (uiData[i].record.video_play_time / uiData[i].record.video_total_time) * 100;
                id = uiData[i].record.cid;
              }
              if (uiData[i].record.primary_category === 10) {
                labels[1] = { text: uiData[i].record.update_time };
              } else {
                if (uiData[i].record.type === 1) {
                  if (uiData[i].record.full_episode_count === uiData[i].record.update_episode) {
                    labels[1] = { text: uiData[i].record.full_episode_count, type: 1 }; // type 1 全集
                  } else {
                    labels[1] = { text: uiData[i].record.update_episode, type: 2 }; // type 2 更新到几集
                  }
                } else if (uiData[i].record.type === 2) {
                  labels[1] = { text: '', type: 3 }; // type 3 只显示观看不显示集数
                } else {
                  labels[1] = { text: '', type: 0 }; // type 0 不显示
                }
              }
              history.push({
                id,
                vid: uiData[i].record.vid,
                index: i + 1,
                isFocus: false,
                labels,
                pic: uiData[i].poster.img_url,
                subtitle: uiData[i].poster.main_title,
                title: uiData[i].poster.main_title,
                watchProgress: Math.abs(Math.round(watchProgress)),
                item_pos: i,
                type: uiData[i].record.type,
                isOffShelf: uiData[i].poster.off_shelf_status,
              });
              // 我的页观看历史海报模块曝光上报
              report({
                attaId: '02d00063512',
                element_id: 'linuxtv_account',
                mod_id: '',
                mod_pos: 0,
                mod_name: '观看历史',
                item_pos: i,
                cid: id,
                vid: uiData[i].record.vid,
                main_cid: '',
                main_vid: '',
              });
            }
          }
          this.setState({
            history: history.slice(0, 3),
          });
          if (history.length) {
            this.historyEls();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // 专辑添加方法
  historyEls() {
    const historyEls = document.querySelectorAll('.historyBox');
    // 历史栏目
    historyEls.forEach((el) => {
      el.addEventListener('onFocus', this.historyFocus.bind(this));
      el.addEventListener('onBlur', this.historyBlur.bind(this));
      el.addEventListener('right', this.historyRight.bind(this));
      el.addEventListener('left', this.historyLeft.bind(this));
      el.addEventListener('up', this.historyUp.bind(this));
      el.addEventListener('down', this.historyDown.bind(this));
      el.addEventListener('click', this.historyClick.bind(this));
      el.addEventListener('mouseenter', this.historyMouseenter.bind(this));
    });
    if (getCookie('focalMemory')) {
      const focalMemory = getCookie('focalMemory');
      if (focalMemory === 1) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else if (focalMemory === 2) {
        $tv.requestFocus(this.refs[`historyMark${2}`]);
      } else if (focalMemory === 3) {
        $tv.requestFocus(this.refs[`historyMark${3}`]);
      }
      delCookie('focalMemory');
    }
  }
  // 登录点击
  loginClick() {
    // 登录点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      button: 'login',
    });
    setCookie('focalMemory', 8);
  }
  // 登录鼠标获取焦点
  loginMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.loginMark.current);
  }
  // 登录获取焦点
  loginFocus() {
    this.setState({
      loginFlag: true,
    });
  }
  // 登录失去焦点
  loginBlur() {
    this.setState({
      loginFlag: false,
    });
  }
  // 登录上移
  loginUp() {
    this.props.getMsg(0);
  }
  // 登录下移
  loginDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 登录左移
  loginLeft() {
    $tv.requestFocus(this.loginMark.current);
    let currentLoginAtion = this.state.loginAtion;
    if (currentLoginAtion === '') {
      currentLoginAtion = 1;
      this.setState({
        loginAtion: currentLoginAtion,
      });
      let loginAtionTimer = setTimeout(() => {
        currentLoginAtion = '';
        this.setState({
          loginAtion: currentLoginAtion,
        });
        clearTimeout(loginAtionTimer);
        loginAtionTimer = null;
      }, 800);
    }
  }
  // 退出登录点击
  logoutClick() {
    // 登录点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      button: 'logout',
    });
    setCookie('focalMemory', 9);
  }
  // 退出登录鼠标获取焦点
  logoutMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.logoutMark.current);
  }
  // 退出登录获取焦点
  logoutFocus() {
    this.setState({
      logoutFlag: true,
    });
  }
  // 退出登录失去焦点
  logoutBlur() {
    this.setState({
      logoutFlag: false,
    });
  }
  // 退出登录上移
  logoutUp() {
    this.props.getMsg(0);
  }
  // 退出登录下移
  logoutDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 退出登录左移
  logoutLeft() {
    $tv.requestFocus(this.logoutMark.current);
    let currentLoginAtion = this.state.loginAtion;
    if (currentLoginAtion === '') {
      currentLoginAtion = 1;
      this.setState({
        loginAtion: currentLoginAtion,
      });
      let loginAtionTimer = setTimeout(() => {
        currentLoginAtion = '';
        this.setState({
          loginAtion: currentLoginAtion,
        });
        clearTimeout(loginAtionTimer);
        loginAtionTimer = null;
      }, 800);
    }
  }
  // 点击续费开通
  renewClick() {
    localStorage.setItem(paySessionIdKey, this.state.paySessionId);
    setCookie('vipSourcePage', 'home');
    if (this.state.status === '3') {
      // 续费点击上报
      report({
        attaId: '0e600058578',
        scene: 'linuxtv_account',
        button: 'renew_vip',
      });
    } else {
      // 开通点击上报
      report({
        attaId: '0e600058578',
        scene: 'linuxtv_account',
        button: 'open_vip',
      });
    }
    setCookie('focalMemory', 10);
    // 专辑详情页、播放页、个人中心的赋值分别是2032、2033、2034
    this.props.history.push('/orderVip/2034');
  }
  // 续费开通鼠标获取焦点
  renewMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.renewMark.current);
  }
  // 续费开通获取焦点
  renewFocus() {
    this.setState({
      renewFlag: true,
    });
  }
  // 续费开通失去焦点
  renewBlur() {
    this.setState({
      renewFlag: false,
    });
  }
  // 续费开通上移
  renewUp() {
    this.props.getMsg(0);
  }
  // 续费开通下移
  renewDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 历史栏目抖动逻辑
  historyShake(index) {
    let currentPosterAtion = this.state.posterAtion;
    if (currentPosterAtion === '') {
      currentPosterAtion = index;
      this.setState({
        posterAtion: currentPosterAtion,
      });
      let posterAtionTimer = setTimeout(() => {
        currentPosterAtion = '';
        this.setState({
          posterAtion: currentPosterAtion,
        });
        clearTimeout(posterAtionTimer);
        posterAtionTimer = null;
      }, 800);
    }
  }

  // 历史栏目点击
  historyClick(event) {
    const index = Number(event.target.getAttribute('index'));
    const itemIndex = Number(event.target.getAttribute('item-index'));
    setCookie('focalMemory', this.state.historyIdx);
    // 由于切换直接跳过无法观看视频逻辑可能会很复杂，和产品商量后修改为可聚焦，但跳转时抖动不跳转
    // 点击播控以及下架视频的历史记录时，剧集抖动不跳转
    const historyInfo = this.state.history[index];
    if (historyInfo?.isOffShelf) {
      this.historyShake(itemIndex);
    };
    // 我的页观看历史海报模块点击上报
    report({
      attaId: '06b00063513',
      element_id: 'linuxtv_account',
      mod_id: '',
      mod_pos: 0,
      mod_name: '观看历史',
      item_pos: this.state.history[index].item_pos,
      cid: this.state.history[index].id,
      vid: this.state.history[index].vid,
      main_cid: '',
      main_vid: '',
    });
  }
  // 历史栏目鼠标获取焦点
  historyMouseenter(event) {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    const itemIndex = Number(event.target.getAttribute('item-index'));
    if (this.refs[`historyMark${itemIndex}`] !== undefined) {
      $tv.requestFocus(this.refs[`historyMark${itemIndex}`]);
    }
  }
  // 历史栏目获取焦点
  historyFocus(event) {
    const index = Number(event.target.getAttribute('index'));
    const itemIndex = Number(event.target.getAttribute('item-index'));
    const currentHistory = this.state.history;
    currentHistory[index].isFocus = true;
    this.setState({
      history: currentHistory,
      historyIdx: itemIndex,
    });
  }
  // 历史栏目失去焦点
  historyBlur(event) {
    const index = Number(event.target.getAttribute('index'));
    const itemIndex = Number(event.target.getAttribute('item-index'));
    if (this.state.posterAtion === '') {
      const currentHistory = this.state.history;
      currentHistory[index].isFocus = false;
      this.setState({
        history: currentHistory,
        historyIdx: 0,
      });
      setCookie('historyMark', itemIndex);
    }
  }
  // 历史栏目左移
  historyLeft(event) {
    const index = Number(event.target.getAttribute('index'));
    const itemIndex = Number(event.target.getAttribute('item-index'));
    if (index === 0) {
      this.historyShake(itemIndex);
      if (this.refs[`historyMark${itemIndex}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${itemIndex}`]);
      }
    } else {
      this.setState({
        posterAtion: '',
      });
    }
  }
  // 历史栏目右移
  historyRight() {
    this.setState({
      posterAtion: '',
    });
  }
  // 历史栏目上移
  historyUp() {
    $tv.distanceToCenter = false;
    window.scrollTo(0, 0); // 滚动条返回顶部
    this.setState({
      posterAtion: '',
    });
    if (this.state.isLogin) {
      $tv.requestFocus(this.logoutMark.current);
    } else {
      $tv.requestFocus(this.loginMark.current);
    }
  }
  // 历史栏目下移
  historyDown() {
    const itemIndex = Number(event.target.getAttribute('item-index'));
    if (this.refs[`historyMark${itemIndex}`] !== undefined) {
      $tv.requestFocus(this.refs[`historyMark${itemIndex}`]);
    }
    this.setState({
      posterAtion: '',
    });
  }
  // 查看更多历史点击
  allImgClick() {
    // 更多历史点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      module: 'history',
      button: 'all_history',
    });
    setCookie('focalMemory', 4);
  }
  // 查看更多历史鼠标获取焦点
  allImgMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.allHistoryMark.current);
  }
  // 查看更多历史获取焦点
  allImgFocus() {
    setCookie('allHistoryMark', 1);
    const allImg = document.getElementsByClassName('allImg');
    const allTitle = document.getElementsByClassName('allTitle');
    allTitle[0].style.bottom = `${100 / global.constants.rootValue}rem`;
    allImg[0].src = require('../../assets/img/allHistory_h.png').default;
    allImg[0].style.top = `${-15 / global.constants.rootValue}rem`;
    allImg[0].style.left = `${-15 / global.constants.rootValue}rem`;
    allImg[0].style.width = `${(408 + 28) / global.constants.rootValue}rem`;
    allImg[0].style.height = `${(230 + 30) / global.constants.rootValue}rem`;
  }
  // 查看更多历史失去焦点
  allImgBlur() {
    this.setState({
      allHistoryAtion: '',
    });
    const allImg = document.getElementsByClassName('allImg');
    const allTitle = document.getElementsByClassName('allTitle');
    allTitle[0].style.bottom = `${80 / global.constants.rootValue}rem`;
    allImg[0].src = require('../../assets/img/allHistory_s.png').default;
    allImg[0].style.top = '0rem';
    allImg[0].style.left = '0rem';
    allImg[0].style.width = `${408 / global.constants.rootValue}rem`;
    allImg[0].style.height = `${230 / global.constants.rootValue}rem`;
  }
  // 查看更多历史左移
  allImgLeft() {
    delCookie('allHistoryMark');
  }
  // 查看更多历史右移
  allImgRight() {
    $tv.requestFocus(this.allHistoryMark.current);
    let currentAllHistoryAtion = this.state.allHistoryAtion;
    if (currentAllHistoryAtion === '') {
      currentAllHistoryAtion = 1;
      this.setState({
        allHistoryAtion: currentAllHistoryAtion,
      });
      let allHistoryAtionTimer = setTimeout(() => {
        currentAllHistoryAtion = '';
        this.setState({
          allHistoryAtion: currentAllHistoryAtion,
        });
        clearTimeout(allHistoryAtionTimer);
        allHistoryAtionTimer = null;
      }, 800);
    }
  }
  // 查看更多历史上移
  allImgUp() {
    $tv.distanceToCenter = false;
    window.scrollTo(0, 0); // 滚动条返回顶部
    if (this.state.history.length < 2) {
      if (this.state.isLogin) {
        $tv.requestFocus(this.logoutMark.current);
      } else {
        $tv.requestFocus(this.loginMark.current);
      }
    } else {
      $tv.requestFocus(this.aboutUsMark.current);
    }
  }
  // 设置点击
  setUpClick() {
    // 设置点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      button: 'setting',
    });
    setCookie('focalMemory', 7);
  }
  // 设置鼠标获取焦点
  setUpMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.setUpMark.current);
  }
  // 设置获取焦点
  setUpFocus() {
    const setUpImg = document.getElementsByClassName('setUpImg');
    const setUpTitle = document.getElementsByClassName('setUpTitle');
    setUpTitle[0].style.bottom = `${140 / global.constants.rootValue}rem`;
    setUpImg[0].src = require('../../assets/img/setUp_h.png').default;
    setUpImg[0].style.top = `${-15 / global.constants.rootValue}rem`;
    setUpImg[0].style.left = `${-15 / global.constants.rootValue}rem`;
    setUpImg[0].style.width = `${(260 + 28) / global.constants.rootValue}rem`;
    setUpImg[0].style.height = `${(364 + 30) / global.constants.rootValue}rem`;
  }
  // 设置失去焦点
  setUpBlur() {
    const setUpImg = document.getElementsByClassName('setUpImg');
    const setUpTitle = document.getElementsByClassName('setUpTitle');
    setUpTitle[0].style.bottom = `${120 / global.constants.rootValue}rem`;
    setUpImg[0].src = require('../../assets/img/setUp_s.png').default;
    setUpImg[0].style.top = '0rem';
    setUpImg[0].style.left = '0rem';
    setUpImg[0].style.width = `${260 / global.constants.rootValue}rem`;
    setUpImg[0].style.height = `${364 / global.constants.rootValue}rem`;
  }
  // 设置上移
  setUpUp() {
    this.props.getMsg(0);
  }
  // 设置下移
  setUpDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 设置右移
  setUpRight() {
    $tv.requestFocus(this.helpMark.current);
  }
  // 设置左移
  setUpLeft() {
    if (this.renewMark.current !== null) {
      $tv.requestFocus(this.renewMark.current);
    }
    if (this.loginMark.current !== null) {
      $tv.requestFocus(this.loginMark.current);
    }
  }
  // 帮助点击
  helpClick() {
    // 帮助点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      button: 'feedback',
    });
    setCookie('focalMemory', 6);
  }
  // 帮助鼠标获取焦点
  helpMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.helpMark.current);
  }
  // 帮助获取焦点
  helpFocus() {
    const helpImg = document.getElementsByClassName('helpImg');
    const helpTitle = document.getElementsByClassName('helpTitle');
    helpTitle[0].style.bottom = `${140 / global.constants.rootValue}rem`;
    helpImg[0].src = require('../../assets/img/help_h.png').default;
    helpImg[0].style.top = `${-15 / global.constants.rootValue}rem`;
    helpImg[0].style.left = `${-15 / global.constants.rootValue}rem`;
    helpImg[0].style.width = `${(260 + 28) / global.constants.rootValue}rem`;
    helpImg[0].style.height = `${(364 + 30) / global.constants.rootValue}rem`;
  }
  // 帮助失去焦点
  helpBlur() {
    const helpImg = document.getElementsByClassName('helpImg');
    const helpTitle = document.getElementsByClassName('helpTitle');
    helpTitle[0].style.bottom = `${120 / global.constants.rootValue}rem`;
    helpImg[0].src = require('../../assets/img/help_s.png').default;
    helpImg[0].style.top = '0rem';
    helpImg[0].style.left = '0rem';
    helpImg[0].style.width = `${260 / global.constants.rootValue}rem`;
    helpImg[0].style.height = `${364 / global.constants.rootValue}rem`;
  }
  // 帮助上移
  helpUp() {
    this.props.getMsg(0);
  }
  // 帮助下移
  helpDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 帮助右移
  helpRight() {
    $tv.requestFocus(this.aboutUsMark.current);
  }
  // 帮助左移
  helpLeft() {
    $tv.requestFocus(this.setUpMark.current);
  }
  // 关于点击
  aboutUsClick() {
    // 关于点击上报
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_account',
      button: 'about',
    });
    setCookie('focalMemory', 5);
  }
  // 关于鼠标获取焦点
  aboutUsMouseenter() {
    Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 8 });
    $tv.requestFocus(this.aboutUsMark.current);
  }
  // 关于获取焦点
  aboutUsFocus() {
    const aboutUsImg = document.getElementsByClassName('aboutUsImg');
    const aboutUsTitle = document.getElementsByClassName('aboutUsTitle');
    aboutUsTitle[0].style.bottom = `${140 / global.constants.rootValue}rem`;
    aboutUsImg[0].src = require('../../assets/img/aboutUs_h.png').default;
    aboutUsImg[0].style.top = `${-15 / global.constants.rootValue}rem`;
    aboutUsImg[0].style.left = `${-15 / global.constants.rootValue}rem`;
    aboutUsImg[0].style.width = `${(260 + 28) / global.constants.rootValue}rem`;
    aboutUsImg[0].style.height = `${(364 + 30) / global.constants.rootValue}rem`;
  }
  // 关于失去焦点
  aboutUsBlur() {
    this.setState({
      aboutUsAtion: '',
    });
    const aboutUsImg = document.getElementsByClassName('aboutUsImg');
    const aboutUsTitle = document.getElementsByClassName('aboutUsTitle');
    aboutUsTitle[0].style.bottom = `${120 / global.constants.rootValue}rem`;
    aboutUsImg[0].src = require('../../assets/img/aboutUs_s.png').default;
    aboutUsImg[0].style.top = '0rem';
    aboutUsImg[0].style.left = '0rem';
    aboutUsImg[0].style.width = `${260 / global.constants.rootValue}rem`;
    aboutUsImg[0].style.height = `${364 / global.constants.rootValue}rem`;
  }
  // 关于上移
  aboutUsUp() {
    this.props.getMsg(0);
  }
  // 关于下移
  aboutUsDown() {
    $tv.distanceToCenter = true;
    if (getCookie('allHistoryMark')) {
      $tv.requestFocus(this.allHistoryMark.current);
    } else if (getCookie('historyMark')) {
      const mark = getCookie('historyMark');
      if (this.refs[`historyMark${mark}`] !== undefined) {
        $tv.requestFocus(this.refs[`historyMark${mark}`]);
      }
    } else {
      if (this.state.history.length) {
        $tv.requestFocus(this.refs[`historyMark${1}`]);
      } else {
        $tv.requestFocus(this.allHistoryMark.current);
      }
    }
  }
  // 关于左移
  aboutUsLeft() {
    $tv.requestFocus(this.helpMark.current);
  }
  // 关于右移
  aboutUsRight() {
    $tv.requestFocus(this.aboutUsMark.current);
    let currentAboutUsAtion = this.state.aboutUsAtion;
    if (currentAboutUsAtion === '') {
      currentAboutUsAtion = 1;
      this.setState({
        aboutUsAtion: currentAboutUsAtion,
      });
      let aboutUsAtionTimer = setTimeout(() => {
        currentAboutUsAtion = '';
        this.setState({
          aboutUsAtion: currentAboutUsAtion,
        });
        clearTimeout(aboutUsAtionTimer);
        aboutUsAtionTimer = null;
      }, 800);
    }
  }
  render() {
    return (
      <div className="content_mine">
        <div className="content_personal">
          {this.state.isLogin ? (
            <div className="content_information">
              {this.state.accountImg !== '' ? (
                <img className="user_account" src={this.state.accountImg.default} alt="" />
              ) : null}
              {this.state.avatar !== '' ? (
                <img className="user_avatar" src={this.state.avatar} alt="" />
              ) : null}
              {this.state.status === '3' ? (
                <img className="user_vip" src={this.state.vipImg.default} alt="" />
              ) : null}
              <span
                className="phone_number"
                style={{
                  bottom:
                    this.state.status === '3'
                      ? `${185 / global.constants.rootValue}rem`
                      : `${160 / global.constants.rootValue}rem`,
                }}
              >
                {this.state.user_nick}
              </span>
              {this.state.status === '3' ? (
                <span className="expiry_time">
                  {this.props.t('到期时间:')}
                  {this.state.end}
                </span>
              ) : null}
              <div className="login_div">
                <Link to={'/signOut/'} style={{ color: 'transparent' }}>
                  <span
                    focusable
                    ref={this.logoutMark}
                    className={[
                      this.state.logoutFlag === true ? 'log_out_h' : 'log_out_s',
                      this.state.loginAtion === 1 ? 'allHistoryShake' : null,
                    ].join(' ')}
                  >
                    {this.props.t('退出登录')}
                  </span>
                </Link>
                <span
                  focusable
                  ref={this.renewMark}
                  className={[this.state.renewFlag === true ? 'renew_h' : 'renew_s'].join(' ')}
                  dt-eid="button"
                  dt-params={`mod_id=login_mod&button_name=${this.state.status === '3' ? 'renew_vip' : 'open_vip'}&isLogin=${this.state.isLogin ? '1' : '0'}&pay_session_id=${this.state.paySessionId}&pay_scene=VIP`}
                >
                  <Marquee
                    children={this.state.status === '3'
                      ? this.props.t('续费VIP')
                      : this.props.t('开通VIP')}
                    mainWidth={200}
                    scrollStatus={this.state.renewFlag}
                    index={1}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="content_information">
              <span className="login_prompt">{this.props.t('登录即可同步观看历史')}</span>
              <div className="login_div">
                <Link to={'/login/'} style={{ color: 'transparent' }} className="logindivLink">
                  <span
                    focusable
                    ref={this.loginMark}
                    className={[
                      this.state.loginFlag === true ? 'login_but_h' : 'login_but_s',
                      this.state.loginAtion === 1 ? 'allHistoryShake' : null,
                    ].join(' ')}
                  >
                    <Marquee
                      children={this.props.t('立即登录')}
                      mainWidth={200}
                      scrollStatus={this.state.loginFlag}
                      index={1}
                    />
                  </span>
                </Link>
              </div>
            </div>
          )}
          <Link to={'/setUp/'} style={{ color: 'transparent' }}>
            {/* <Link to={'/particular/ux6vfg23nkozvnj/homepage/'} style={{ color: 'transparent' }}> */}
            <div className="content_setUp" focusable ref={this.setUpMark}>
              <img className="setUpImg" src={this.state.setUpImg.default} alt="" />
              <span
                className={localStorage.getItem('v_channel_id') === '16614' ? 'setUpTitle Astro' : 'setUpTitle'}
              >
                {this.props.t('设置')}
              </span>
            </div>
          </Link>
          <Link to={'/helpFeedback/'} style={{ color: 'transparent' }}>
            <div className="content_help" focusable ref={this.helpMark}>
              <img className="helpImg" src={this.state.helpImg.default} alt="" />
              <span
                className={localStorage.getItem('v_channel_id') === '16614' ? 'helpTitle Astro' : 'helpTitle'}
              >
                {this.props.t('帮助&反馈')}
              </span>
            </div>
          </Link>
          <Link to={'/softwareInfo/'} style={{ color: 'transparent' }}>
            <div
              className={[
                'content_aboutUs',
                this.state.aboutUsAtion === 1 ? 'allHistoryShake' : null,
                localStorage.getItem('v_channel_id') === '16614' ? 'Astro' : null,
              ].join(' ')}
              focusable
              ref={this.aboutUsMark}
            >
              <img className="aboutUsImg" src={this.state.aboutUsImg.default} alt="" />
              <span className="aboutUsTitle">{this.props.t('关于我们')}</span>
            </div>
          </Link>
        </div>
        <div className="content_history">
          <span className="history_title">{this.props.t('观看历史')}</span>
          <div className="history_div">
            <div className="history_Media">
              {this.state.history.map((item, i) => (
                <Link
                  to={item?.isOffShelf ? '' : `/particular/${item.id}/mine/`}
                  key={i}
                  style={{ color: 'transparent' }}
                >
                  <div
                    className={[
                      'historyBox',
                      item.isFocus ? 'focusable' : null,
                    ].join(' ')}
                    ref={`historyMark${item.index}`}
                    index={i}
                    item-index={item.index}
                    focusable
                  >
                    <NewPictureBox
                      posterBox={{
                        posterArr: { ...item },
                        posterAnimation: this.state.posterAtion,
                        posterIndex: item.index,
                      }}
                      isChecked={true}
                    />
                  </div>
                </Link>
              ))}
              <Link to={'/watchHistory/'} style={{ color: 'transparent' }}>
                <div
                  focusable
                  className={[
                    'allHistory',
                    this.state.allHistoryAtion === 1 ? 'allHistoryShake' : null,
                  ].join(' ')}
                  ref={this.allHistoryMark}
                >
                  <img className="allImg" src={this.state.allImg.default} alt="" />
                  <span className="allTitle">{this.props.t('全部历史')}</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
});
